<template>
  <div>
    <form class="z-2" @submit.prevent="saveWorkshop()">
      <div class="bg-grey-academy-150 px-10 flex justify-center items-center">
        <h4 class="font-medium text-xl text-black uppercase w-full flex justify-center">
          Add new workshop </h4>
        <div class="my-5">
          <modal-button :buttonPlaceholder="$t('slotsCreation.save')"
            buttonClass="uppercase" />
        </div>
      </div>
      <div class="mx-10 my-12">
        <div class="flex flex-col justify-start mb-6 uppercase font-sans-serif
          text-xs">
          Title
          <input v-model="title"
            class="outline-none border border-beige-academy-500 mt-3 p-1 rounded" />
        </div>
        <div class="flex flex-col justify-start mb-4 font-sans-serif uppercase w-full text-xs">
          Description
          <textarea v-model="description"
            class="outline-none border border-beige-academy-500 mt-3 p-1 rounded" />
        </div>
        <div class="flex w-full items-center justify-between mb-6 font-sans-serif uppercase">
          <div class="flex justify-start text-xs items-center w-1/2 mr-3">
            Start day:
            <div class="border border-beige-academy-500 p-1 rounded ml-4">
              <datetime
                :min-datetime="minDatetime"
                v-model="day"
                :zone="timezone"
                :value-zone="timezone"
                type="date"
                class="h-1/3 mx-2 w-full" />
            </div>
          </div>
          <div class="flex justify-start w-1/2 uppercase font-sans-serif items-center">
            <span class=" text-xs mr-1">Days number:</span>
            <input v-model="daysNumber" type="number"
              class="outline-none border border-beige-academy-500 ml-4 p-1 rounded" />
          </div>
        </div>

        <div v-if="sameTimeAllDays" class="flex">
          <div class="flex justify-start mb-2 uppercase font-sans-serif text-xs w-1/2
            items-center">
            {{ $t('slotsCreation.startHour') }}:
            <datetime
              type="time"
              class="border border-beige-academy-500 p-1 w-2/3 rounded ml-4"
              v-model="start"
              :minute-step="minuteStep"
              :zone="timezone"
              :value-zone="timezone"
              placeholder="Select time" />
          </div>

          <div class="mb-2 flex justify-start uppercase font-sans-serif text-xs w-1/2 ml-2
            items-center">
            {{ $t('slotsCreation.endHour') }}:
            <datetime
              type="time"
              class="border border-beige-academy-500 p-1 w-2/3 rounded ml-4"
              v-model="end"
              :minute-step="minuteStep"
              :zone="timezone"
              :value-zone="timezone"
              placeholder="Select time" />
          </div>
        </div>
        <div v-else v-for="i in parseInt(daysNumber)" :key="i" class="mt-6">
          <div class="flex justify-start mb-2 uppercase font-sans-serif text-xs w-2/3">
            {{ $t('slotsCreation.startHour') }} day {{ i }}
            <datetime
              type="time"
              class="border border-beige-academy-500 h-1/3 p-1 mx-2 rounded"
              v-model="workshopDays[i-1].start"
              :minute-step="minuteStep"
              :zone="timezone"
              :value-zone="timezone"
              placeholder="Select time" />
          </div>

          <div class="mb-2 flex text-xs w-2/3 uppercase font-sans-serif mt-3">
            {{ $t('slotsCreation.endHour') }} day {{ i }}
            <datetime
              type="time"
              class="border border-beige-academy-500 h-1/3 p-1 mx-5 rounded"
              v-model="workshopDays[i-1].end"
              :minute-step="minuteStep"
              :zone="timezone"
              :value-zone="timezone"
              placeholder="Select time" />
          </div>
        </div>
        <div class="flex items-center justify-end" v-if="daysNumber>1">
          <input type="checkbox" id="same-time"
            v-model="sameTimeAllDays">
          <label for="same-time" class="pl-2 font-sans-serif uppercase text-xs">
            Same time for all days</label>
        </div>

        <div class="text-xs font-sans-serif flex justify-between mb-6 w-full mt-3 items-center">
          <span class="w-auto uppercase mr-2">Max participants</span>
          <input v-model="participants" type="number" placeholder="unlimited"
            class="outline-none border border-beige-academy-500 w-4/5 p-1 rounded" />
        </div>
      </div>

    </form>

  </div>
</template>

<style scoped>
  @import 'https://unpkg.com/vue-datetime/dist/vue-datetime.css';
</style>

<script>
// import { MDCCheckbox } from '@material/checkbox';
// import { MDCFormField } from '@material/form-field';
import axios from 'axios';
import { Datetime } from 'vue-datetime';
import { mapActions, mapGetters } from 'vuex';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import DatesConversion from '@/mixins/DatesConversion';
import dayjs from 'dayjs';
import ModalButton from '../graphics/ModalButton.vue';

/* const checkbox = new MDCCheckbox(document.querySelector('.mdc-checkbox'));
const formField = new MDCFormField(document.querySelector('.mdc-form-field'));
formField.input = checkbox; */

export default {
  data() {
    return {
      slots: [],

      title: '',
      day: null,
      start: null,
      end: null,
      description: '',
      participants: null,
      price: null,

      minuteStep: 15,
      isLogged: true,
      minDatetime: dayjs.tz().toISOString(),

      sameTimeAllDays: true,
      daysNumber: 1,

      workshopDays: [],
    };
  },

  mixins: [StreamFunctionsMixin, DatesConversion],

  computed: {
    ...mapGetters({
      timezone: 'timezone/choosenTimezone',
    }),

    mDay() {
      return dayjs(this.day);
    },

    mHourStart() {
      return dayjs(this.start);
    },

    mHourEnd() {
      return dayjs(this.end);
    },
  },

  props: {
    id: Number,
    savedSlots: Array,
  },

  components: {
    datetime: Datetime,
    ModalButton,
  },

  watch: {
    daysNumber() {
      if (!this.oneDayMasterclass) {
        do {
          this.addAWorkshopDay(this.changeDateFormatForCalendarAndDatabase(this.getDateObject(this.day).add(this.workshopDays.length, 'day')));
        } while (this.workshopDays.length < this.daysNumber);
      }
    },
  },

  methods: {
    createSlots() {
      if (this.generateSlots()) {
        this.saveSlots();
      }
    },

    getDate(time) {
      const dayExtracted = this.day.split('T')[0];
      const timeExtracted = time.split('T')[1];

      return this.changeDateFormatForCalendarAndDatabase(this.convertDateTimezoneForDatabase(`${dayExtracted}T${timeExtracted}`));
    },

    getDateObject(time) {
      const dayExtracted = this.day.split('T')[0];
      const timeExtracted = time.split('T')[1];

      return this.convertDateTimezoneForDatabase(`${dayExtracted}T${timeExtracted}`);
    },

    saveWorkshop() {
      const workshop = {
        title: this.title,
        description: this.description,
        start_day: '',
        days: this.daysNumber,
        max_participants: this.participants,
        price: this.price,
      };

      const day = this.getDate(this.start ? this.start : this.workshopDays[0].day);
      const hour = this.getDate(this.start ? this.start : this.workshopDays[0].start);
      const start = `${day.split(' ')[0]} ${hour.split(' ')[1]}`;

      workshop.start_day = start;

      axios.post(`/api/teachers/${this.id}/workshop`, workshop)
        .then(({ data }) => {
          this.workshopDays.forEach((workshopDay) => {
            const currentDay = workshopDay;
            currentDay.day = this.getDate(currentDay.day);
            currentDay.start = this.getDate(currentDay.start);
            currentDay.end = this.getDate(currentDay.end);
          });
          axios.post(`/api/workshops/${data.id}/days`, { days: this.workshopDays })
            .then(() => {
              this.createNotification('success', 'Workshop salvato con successo');
              this.updatedSlots(true);
              this.$emit('close');
            })
            .catch((errors) => {
              console.log(errors);
            });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    addAWorkshopDay(day) {
      this.workshopDays.push({
        day,
        start: '',
        end: '',
      });
    },

    ...mapActions({
      updatedSlots: 'slots/updatedSlots',
    }),

  },

};
</script>
